// extracted by mini-css-extract-plugin
export var root = "Wzv2T3sKBLIFLBI2ILod";